<template>
  <div>
    <div class="containter">
      <div class="logo_header">
        <!-- <div class="logo"></div> -->
      </div>
      <div class="login">
        <div class="outer">
          <div class="title">统一登录后台系统</div>
          <el-input
            ref="name"
            v-model="name"
            placeholder="请输入用户名"
            style="margin-top: 1rem; width: 19.5rem; margin-left: 1rem"
          ></el-input>
          <div>
            <el-input
              ref="password"
              v-model="password"
              placeholder="请输入密码"
              type="password"
              style="margin-top: 1rem; width: 19.5rem; margin-left: 1rem"
            ></el-input>
            <!-- <span class="resign">注册</span>
            <span class="forget">忘记密码</span>-->
          </div>
          <div>
            <el-button
              type="primary"
              @click="login"
              style="
                width: 100%;
                margin-top: 1rem;
                width: 19.5rem;
                margin-left: 1rem;
              "
              >登录</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      版权所有 卫创平台 鄂ICP备2024084485号-2
      <br />
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    // 绑定enter事件
    this.enterKeyup();
  },
  destroyed() {
    // 销毁enter事件
    this.enterKeyupDestroyed();
  },
  data() {
    return {
      dialogVisible: true,
      name: "",
      password: "",
    };
  },
  methods: {
    login() {
      if (this.name.trim() == "") {
        this.$refs.name.focus();
        this.$message({
          message: "用户名不能为空",
          type: "warning",
        });
        return;
      } else if (this.password.trim() == "") {
        this.$refs.password.focus();
        this.$message({
          message: "密码不能为空",
          type: "warning",
        });
        return;
      }
      console.log(this.name, this.password);
      this.$api
        .login({
          username: this.name,
          password: this.password,
        })
        .then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            sessionStorage.setItem("access_token", res.data.data.access_token);
            sessionStorage.setItem("admin", res.data.data.user.username);
            sessionStorage.setItem("orgId", res.data.data.user.orgId);
            sessionStorage.setItem("grp", res.data.data.user.grp);
            sessionStorage.setItem(
              "openStat",
              res.data.data.user.openStat ? 1 : 0,
            );
            sessionStorage.removeItem("tab");
            // this.$router.replace('/')
            this.$router.push({
              name: "user",
            });
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    enterKey(event) {
      const code = event.keyCode
        ? event.keyCode
        : event.which
        ? event.which
        : event.charCode;
      if (code == 13) {
        this.login();
      }
    },
    enterKeyupDestroyed() {
      document.removeEventListener("keyup", this.enterKey);
    },
    enterKeyup() {
      document.addEventListener("keyup", this.enterKey);
    },
  },
};
</script>

<style scoped>
.containter {
  height: 590px;
  background: url(../assets/img/login-banner-bg.jpg) no-repeat center center;
}
.logo_header {
  height: 80px;
  background: #00ab71;
  position: relative;
}
.logo {
  background: url(../assets/logo.png) no-repeat;
  height: 180px;
  width: 268px;
  position: absolute;
  top: 0;
  left: 50%;
  margin-left: -134px;
  z-index: 2;
}
.login {
  position: relative;
  width: 24rem;
  padding: 1rem;
  left: 60%;
  top: 10rem;
  border-radius: 4px;
  /* transform: translate(-50%); */
  background: rgba(0, 0, 0, 0.3);
}
.title {
  width: 20rem;
  font-size: 1.5rem;
  color: #fff;
  text-align: center;
}
.forget {
  font-size: 0.7rem;
  float: right;
  cursor: pointer;
  position: relative;
  margin-right: 0.5rem;
  z-index: 2;
}
.forget:hover {
  color: #00ab71;
}
.resign {
  font-size: 0.7rem;
  cursor: pointer;
  margin-left: 1rem;
  position: relative;
  z-index: 2;
}
.resign:hover {
  color: #00ab71;
}
.login ::v-deep.el-button--primary {
  background: #00ab71;
  border: #00ab71;
}
.footer {
  text-align: center;
  margin: 10px 0;
  color: #999;
  line-height: 24px;
  font-size: 14px;
}
</style>
